const pickValues = <T extends Record<string, unknown>>(source: T, keys: (keyof T)[]) => keys.map((key) => source[key])

export default pickValues
